import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.modal-label',
		defaultMessage:
			'Link to related work. Current issue: {issueType} {issueKey} {issueSummary}. {isLoading}',
		description:
			'Modal label used to announce necessary contextual information on modal open. Edit Dates modal used to change the start and due date of issues on the simple timeline',
	},
	isLoadingLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.is-loading-label',
		defaultMessage: 'Issue links are loading.',
		description:
			'Label announced to users using assistive technology when the issue dependency information is currently loading in the edit dependency modal.',
	},
	finishedLoadingLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.finished-loading-label',
		defaultMessage: 'Finished loading issue links.',
		description:
			'Label announced to users using assistive technology when the issue dependency information is currently loading in the edit dependency modal.',
	},
	title: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.title',
		defaultMessage: 'Link to related work',
		description:
			'Title of the edit dependency modal which is used to update links between issues in the project timeline.',
	},
	description: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.description',
		defaultMessage: 'Connect issues to indicate the order in which they need to be done.',
		description:
			'Description of the edit dependency modal which is used to update links between issues in the project timeline.',
	},
	selectedIssueLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.selected-issue-label',
		defaultMessage: 'This issue',
		description: 'Label for the currently selected issue in the edit dependency modal.',
	},
	linkedIssuesLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.linked-issues-label',
		defaultMessage: 'Linked issues',
		description:
			'Label for the list of dependencies in the edit dependency modal, which is used to update links between issues in the project timeline.',
	},
	blocks: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.blocks',
		defaultMessage: 'Blocks',
		description: 'Label for issue dependencies with the "Blocks" link type.',
	},
	blockedBy: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.blocked-by',
		defaultMessage: 'Is blocked by',
		description: 'Label for issue dependencies with the "Is blocked by" link type.',
	},
	linkIssueLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.link-issue-label',
		defaultMessage: 'Link issue',
		description:
			'Label for the input form to create a new link between two issues via the edit dependency modal in the project timeline.',
	},
	linkTypePlaceholder: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.link-type-placeholder',
		defaultMessage: 'Select link type',
		description:
			'Placeholder for the select input that determines the link type when creating a new link between two issues via the edit dependency modal in the project timeline.',
	},
	selectLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.select-label',
		defaultMessage: 'Create new link',
		description:
			'Placeholder for the select inputs that determines the link type/linked issue when creating a new link between two issues via the edit dependency modal in the project timeline.',
	},
	selectIssuePlaceholder: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.select-issue-placeholder',
		defaultMessage: 'Select an issue',
		description:
			'Placeholder for the search/select input when creating a new link between two issues via the edit dependency modal in the project timeline.',
	},
	add: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.add',
		defaultMessage: 'Link',
		description:
			'Text for the button that adds a dependency link between two issues via the edit dependency modal in the project timeline.',
	},
	addAriaLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.add-aria-label',
		defaultMessage: 'Add link',
		description:
			'Aria label for the button that adds a dependency link between two issues via the edit dependency modal in the project timeline.',
	},
	close: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.close',
		defaultMessage: 'Close',
		description:
			'Text for the button that closes the edit dependency modal in the simple timeline.',
	},
	closeIconLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.close-icon-label',
		defaultMessage: 'Close modal',
		description:
			'Label for the close icon button responsible for closing the edit dependency modal in the simple timeline.',
	},
	warning: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.warning',
		defaultMessage: 'Warning',
		description: 'Label for the warning icon',
	},
	issueInfoLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.issue-info-label',
		defaultMessage: 'Issue {issueType} {issueKey} {issueSummary}',
		description: 'Label for each option in a select input that allows the user to select an issue.',
	},
	errorMessage: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.error-message',
		defaultMessage: 'Warning: {error}',
		description: 'Warning message to be announced to the user.',
	},
	fixedWarnings: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.fixed-warnings',
		defaultMessage: 'No more warnings',
		description: 'Message to be announced to the user when they have fixed the existing warnings',
	},
	modalLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.modal-label-issue-term-refresh',
		defaultMessage:
			'Link to related work. Current work item: {issueType} {issueKey} {issueSummary}. {isLoading}',
		description:
			'Modal label used to announce necessary contextual information on modal open. Edit Dates modal used to change the start and due date of issues on the simple timeline',
	},
	isLoadingLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.is-loading-label-issue-term-refresh',
		defaultMessage: 'Work item links are loading.',
		description:
			'Label announced to users using assistive technology when the issue dependency information is currently loading in the edit dependency modal.',
	},
	finishedLoadingLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.finished-loading-label-issue-term-refresh',
		defaultMessage: 'Finished loading work item links.',
		description:
			'Label announced to users using assistive technology when the issue dependency information is currently loading in the edit dependency modal.',
	},
	descriptionIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.description-issue-term-refresh',
		defaultMessage:
			'Link work items to connect work between software and <a>business projects</a>, and other project types in Jira.',
		description:
			'Description of the edit dependency modal which is used to update links between issues in the project timeline.',
	},
	selectedIssueLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.selected-issue-label-issue-term-refresh',
		defaultMessage: 'This work item',
		description: 'Label for the currently selected issue in the edit dependency modal.',
	},
	linkedIssuesLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.linked-issues-label-issue-term-refresh',
		defaultMessage: 'Linked work items',
		description:
			'Label for the list of dependencies in the edit dependency modal, which is used to update links between issues in the project timeline.',
	},
	linkIssueLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.link-issue-label-issue-term-refresh',
		defaultMessage: 'Link work item',
		description:
			'Label for the input form to create a new link between two issues via the edit dependency modal in the project timeline.',
	},
	selectIssuePlaceholderIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.select-issue-placeholder-issue-term-refresh',
		defaultMessage: 'Select a work item',
		description:
			'Placeholder for the search/select input when creating a new link between two issues via the edit dependency modal in the project timeline.',
	},
	issueInfoLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.issue-info-label-issue-term-refresh',
		defaultMessage: 'Work item {issueType} {issueKey} {issueSummary}',
		description: 'Label for each option in a select input that allows the user to select an issue.',
	},
});
